const defaultHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'X-Http-Caller-Id': 'auth-pages-react'
};

export function requestGet(path, opts = {}) {
  const { headers } = opts;

  return fetch(path, {
    credentials: 'same-origin',
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
}

export function requestPost(path, opts = {}) {
  const { data, headers = {} } = opts;

  return fetch(path, {
    method: 'post',
    credentials: 'same-origin',
    headers: {
      ...defaultHeaders,
      ...headers
    },
    body: data
  });
}

export function requestPut(path, opts = {}) {
  const { data, headers } = opts;

  return fetch(path, {
    method: 'put',
    credentials: 'same-origin',
    headers: {
      ...defaultHeaders,
      ...headers
    },
    body: data
  });
}

export function requestDelete(path, opts = {}) {
  const { headers } = opts;

  return fetch(path, {
    method: 'delete',
    credentials: 'same-origin',
    headers: {
      ...defaultHeaders,
      ...headers
    }
  });
}
